applicationsSubNavbar.classy.controller({
    name: 'NotesRemindersController',
    inject: ['$scope', '$timeout', 'ApplicationService', 'authServiceFactory', 'VehicleModelFactory', 'SchoolModelService', 'NoteModelService', 'ReminderModelService'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.familyIndex = this.ApplicationService.getFamilyIndex();
        this.model = new this.VehicleModelFactory(this.ApplicationService.getFamilyData().data[0].familyID);
        this.$.familyIndex = this.ApplicationService.getFamilyNo();
        this.$.ApplicationService = this.ApplicationService;
        this.$.versionNo = versionNo;
        this.$.notes = this.ApplicationService.getAwardData()['notes'];
        this.$.reminders = this.ApplicationService.getAwardData()['reminders'];
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.initOpened();

        var nowtime = moment();
        this.$.isArchive = this.ApplicationService.getAwardData().isArchive;
    },
    initOpened: function()
    {
        this.opened = Array();
        this.edited = Array();
        this.edited[0] = Array();
        this.edited[1] = Array();
        this.opened[0] = Array();
        this.opened[1] = Array();
        for (var i = 0; i < this.$.notes.length; i++) {
            this.opened[0][i] = false;
            this.edited[0][i] = false;
        }
        for (var i = 0; i < this.$.reminders.length; i++) {
            this.opened[1][i] = false;
            this.edited[1][i] = false;
        }
    },
    toggleOpen: function(type, index)
    {
        if (this.opened[type][index] == false)
            this.initOpened();
        this.opened[type][index] = !this.opened[type][index];
    },
    getOpened: function(type, index)
    {
        return this.opened[type][index];
    },
    dismiss: function(type)
    {
        if (type==0) {
            this.ApplicationService.getAwardData().notes.pop();
        }
        else {
            this.ApplicationService.getAwardData().reminders.pop();
        }
    },
    getEdited: function(type, index)
    {
        return this.edited[type][index];
    },
    newNR: function(type)
    {
        if (type==0) {
            var ind = this.NoteModelService.new();
        }
        else {
            var ind = this.ReminderModelService.new();
        }
        console.log(type+" "+ind);
        this.toggleEdit(type, ind);
    },
    toggleEdit: function(type, index)
    {
        //if (this.edited[type][index] == undefined)
        //    this.initOpened();
        this.edited[type][index] = !this.edited[type][index];
        console.log(this.edited);
    },
    getField: function(item, field)
    {
        if (item['x' + field] === null || item[field] == item['x' + field])
            return item[field]
        else
            return item['x' + field];
    },
    setCompare: function(value)
    {
        this.$.compare = value;
    },
    momentFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('MMM Do, YYYY h:mm a');
    },
    momentSQLFormat: function(datetime)
    {
        var notetime = moment(datetime)
        return notetime.format('YYYY-MM-D HH:mm:ss');
    },
    startSaveProcess: function(scope, instance, form, type, index)
    {
        this.$.index = index;
        if (form.$valid) {
            this.edited[type][index] = !this.edited[type][index];
            instance.options.factor = .5;
            if (type === 0) {
                this.$.putObject = this.$.notes[index];
                if ((typeof this.$.putObject.recordID !== "undefined")) {
                    return this.NoteModelService.put(this.$.putObject.applicationID, this.$.putObject, instance);
                } else {
                    return this.NoteModelService.post(this.$.putObject.applicationID, this.$.putObject, instance).then((results) => {
                        this.ApplicationService.getAwardData().notes[index].recordID = this.$.notes[index].recordID = results.data.id;
                        let nowtime = moment();
                        this.ApplicationService.getAwardData().notes[index].date = this.momentSQLFormat(nowtime);
                    });
                }
            } else {
                this.$.putObject = this.$.reminders[index];
                if ((typeof this.$.putObject.recordID !== "undefined")) {
                    return this.ReminderModelService.put(this.$.putObject.applicationID, this.$.putObject, instance);
                } else {
                    return this.ReminderModelService.post(this.$.putObject.applicationID, this.$.putObject, instance).then((results) => {
                        this.ApplicationService.getAwardData().reminders[index].recordID = this.$.reminders[index].recordID = results.data.id;
                        let nowtime = moment();
                        this.ApplicationService.getAwardData().reminders[index].date = this.momentSQLFormat(nowtime);
                    });
                }
            }
        } else {
            instance.stop(-1);
        }
    },
    startDeleteProcess: function(scope, instance, form, type, index)
    {
        var parent = this;
        this.$.index = index;
        if (form.$valid)
        {
            instance.options.factor = .5;
            if (type==0) {
                return this.NoteModelService.purge(this.ApplicationService.getAwardData().app[0].applicationID, this.$.notes[index], instance).then(function() {
                    parent.ApplicationService.getAwardData().notes.splice(index, 1);
                })
            }
            else {
                return this.ReminderModelService.purge(this.ApplicationService.getAwardData().app[0].applicationID, this.$.reminders[index], instance).then(function() {
                    parent.ApplicationService.getAwardData().reminders.splice(index, 1);
                })
            }
        }
        else
            instance.stop(-1);
    },
    successSave: function (scope, instance, type)
    {
        this.initOpened();
    },
    successDelete: function (scope, instance, type, index)
    {
        console.log("delete");
        console.log(type+" "+index);
        this.edited[type][index] = false;
        console.log(this.edited);
        if (type==0) {
            this.edited[type].splice(index, 1)
        }
        else {
            this.edited[type].splice(index, 1)
        }
    }
});
